<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-14 18:50:27
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2021-07-16 11:27:06
 * @name: 标题左浮动容器
 * @Description: 标题左浮动容器
 * @FilePath: \backstage\src\components\public\container-float-title.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="containerFloatTitle">
    <div class="head">
      <font>{{title}}</font>
    </div>
    <div class="content">
      <slot/>
    </div>
  </div>
</template>
<script>
export default {
  name: "containerNormal",
  props: {
    title: {
      type: String,
      default: '',
    }
  }
};
</script>
<style lang="scss" scoped>
.containerFloatTitle {
  border-radius: $Vars-border-radius-normal;
  border: 1px solid $Vars-border-third-color;
  .head {
    width: 100%;
    height: 40px;
    padding: 20px;
    box-sizing: border-box;
    @extend .extend-flex-start;
    border-bottom: 1px solid $Vars-border-third-color;
  }
  .content {
    padding: 20px 10px;
    @extend .extend-flex-column-normal;
  }
}
</style>